<template>
  <div class="flex flex-col px-1 py-2 flex-wrap" @click="toggle">

    <div class="flex flex-row items-center justify-between">
      <slot name="AccordionFancyTitle"></slot>
      <button
        :disabled="keepOpened"
        class="flex-1 flex flex-row gap-2 px-2 justify-between items-center">
          <mdn-text name="title" isCaption>{{title}}</mdn-text>
          <span v-if="!isOpen" class="mdn-Icon-baixo mdn-Icon--md"></span>
          <span v-if="isOpen" class="mdn-Icon-cima mdn-Icon--md"></span>
      </button>
    </div>

    <div v-if="isOpen" class="flex flex-wrap flex-1 p-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { MdnText } from 'mondrian-vue'

export default {
  name: 'Accordion',
  components: { MdnText },
  data () {
    return {
      isOpen: false
    }
  },
  props: {
    title: String,
    defaultOpen: { default: false, type: Boolean },
    keepOpened: { default: false, type: Boolean }
  },
  methods: {
    toggle () {
      this.isOpen = !this.isOpen
      this.$emit('stateIsOpen', this.isOpen)
    }
  },
  mounted () {
    this.isOpen = this.defaultOpen
    if (this.keepOpened) this.isOpen = true
  }
}
</script>
